import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DownstreamDatasourcesFilteredByFieldWithoutPersonalSpaceQuery(
  $selectedFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
